import { Divider, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { StyledModal } from "./ModalOnboardSkip.styles";
import { useAuthStore } from "../../stores";
import { ButtonDigited } from "../Button/Button.variants";

// Layout allineato alle modali di conferma del restyle (es. EditionInProgressWarningModal)
export function ModalOnboardingSkip({
  onClose,
  open
}:{
    onClose: () => void
    open: boolean
}){
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const postOnBoardingCompleted = useAuthStore(state => state.postOnBoardingCompleted);

  return (
    <StyledModal
      aria-labelledby="modal-onboarding-skip-title"
      aria-describedby="modal-onboarding-skip-description"
      open={ open }
      sx={ {
        padding: "2rem !important"
      } }
      onClose={ onClose }
    >
      <Stack
        alignItems="center"
        gap="1.25rem"
        sx={ { "&:focus-visible": { outline: "none" } } }
      >
        <Typography
          id="modal-onboarding-skip-title"
          color={ theme.customColors.exploreCardText }
          variant="h2"
          fontSize="1.5rem"
          lineHeight="1.5rem"
          fontWeight={ 600 }
          sx={ { textAlign: "center" } }
        >
          { t("skip_step_onboarding") }
        </Typography>

        <Typography
          id="modal-onboarding-skip-description"
          color={ theme.customColors.exploreCardText }
          fontSize="0.875rem"
          lineHeight="1.25rem"
          sx={ { textAlign: "center", whiteSpace: "pre-line" } }
        >
          { t("skip_step_description") }
        </Typography>

        <Divider
          sx={ {
            borderColor: theme.customColors.border,
            width: "100%"
          } }
        />

        <Stack
          direction="row"
          gap={ 2 }
          sx={ { width: "100%" } }
        >
          <ButtonDigited
            typology={ "secondary" }
            text={ t("yes_skip") }
            onClick={ completeOnboarding }
            sx={ { flex: 1 } }
          />
          <ButtonDigited
            typology={ "primary" }
            text={ t("no_continue") }
            onClick={ onClose }
            sx={ { flex: 1 } }
          />
        </Stack>
      </Stack>
    </StyledModal>
  );

  function completeOnboarding(){
    postOnBoardingCompleted();
    setTimeout(()=> {
      navigate("/");
    },2000);
  }
}
